import { render, staticRenderFns } from "./OverlayRoute.vue?vue&type=template&id=3c0dd23c&scoped=true&lang=pug&"
import script from "./OverlayRoute.vue?vue&type=script&lang=js&"
export * from "./OverlayRoute.vue?vue&type=script&lang=js&"
import style0 from "./OverlayRoute.vue?vue&type=style&index=0&id=3c0dd23c&scoped=true&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../../.yarn/$$virtual/vue-loader-virtual-5d68b12ba1/0/cache/vue-loader-npm-15.9.0-dfd6801660-2.zip/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c0dd23c",
  null
  
)

export default component.exports